import { render, staticRenderFns } from "./editService.vue?vue&type=template&id=b07ae152&scoped=true"
import script from "./editService.vue?vue&type=script&lang=js"
export * from "./editService.vue?vue&type=script&lang=js"
import style0 from "./editService.vue?vue&type=style&index=0&id=b07ae152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07ae152",
  null
  
)

export default component.exports